var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createReducer } from "redux-act";
import * as propertyActions from "./property.actions";
export var REDUCER_KEY_PROPERTY = "property";
var getDefaultState = function () { return ({
    // Property create
    isCreatingProperty: false,
    createPropertyError: undefined,
    createdPropertyId: undefined,
}); };
var reducer = createReducer({}, getDefaultState());
reducer.on("LOG_OUT", function () { return getDefaultState(); });
reducer.on(propertyActions.importPropertyPartnerWhise.types.START, function (state) { return (__assign(__assign({}, state), { isCreatingProperty: true, createPropertyError: undefined, createdPropertyId: undefined })); });
reducer.on(propertyActions.importPropertyPartnerWhise.types.SUCCESS, function (state, property) {
    return __assign(__assign({}, state), { isCreatingProperty: false, createPropertyError: undefined, createdPropertyId: property.id });
});
reducer.on(propertyActions.importPropertyPartnerWhise.types.FAILURE, function (state, _a) {
    var error = _a.error;
    return (__assign(__assign({}, state), { isCreatingProperty: false, createPropertyError: error, createdPropertyId: undefined }));
});
// eslint-disable-next-line import/no-default-export
export default reducer;
